import { IconColor } from "../../../styles/icons";
import { ButtonType } from "../Button/Button";
import { ActionButtonColor } from "./ActionButton";

interface ActionButtonStyles {
    readonly rest: IconColor;
    readonly hover: IconColor;
    readonly pressed: IconColor;
}

export const computeActionButtonTextColor = (type?: ButtonType, disabled?: boolean, color: ActionButtonColor = "themePrimary"): ActionButtonStyles => {
    if (disabled) {
        return {
            rest: "neutralTertiaryAlt",
            hover: "neutralTertiaryAlt",
            pressed: "neutralTertiaryAlt"
        };
    } else if (type === "primary") {
        return {
            rest: "white",
            hover: "white",
            pressed: "white"
        };
    } else if (type === "error") {
        return {
            rest: "errorIcon",
            hover: "warningIcon",
            pressed: "severeWarningIcon"
        };
    } else {
        if (color === "themePrimary") {
            return {
                rest: "themePrimary",
                hover: "themeDark",
                pressed: "themeDarker"
            };
        } else {
            return {
                rest: "neutralPrimary",
                hover: "neutralPrimary",
                pressed: "neutralDark"
            };
        }
    }
};

export const computeActionButtonIconColor = (type?: ButtonType, disabled?: boolean, color: ActionButtonColor = "themePrimary"): ActionButtonStyles => {
    if (type === "error") {
        return {
            rest: "errorIcon",
            hover: "warningIcon",
            pressed: "severeWarningIcon"
        };
    } else {
        return computeActionButtonTextColor(type, disabled, color);
    }
};

export const computeActionButtonHighContrastColor = (type?: ButtonType): string|undefined => {
    if (type !== "primary") {
        return "highlight";
    } else {
        // Primary buttons have a border and thus do not need the text to change color to indicate interactability
        return undefined;
    }
};
